var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapperRef",staticClass:"vue-office-excel"},[_c('div',{ref:"rootRef",staticClass:"vue-office-excel-main",attrs:{"id":"vue-office-excel-main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }